export default "__VITE_ASSET__DZZL3W$5__"